import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: string;
  Dimension: any;
  HexColor: any;
  JSON: any;
  Quality: any;
};

/** An individual article on the Care Resources page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/articlePage) */
export type ArticlePage = Entry & {
  __typename: 'ArticlePage';
  articleBody: Maybe<ArticlePageArticleBody>;
  articleDescription: Maybe<ArticlePageArticleDescription>;
  authorCollection: Maybe<ArticlePageAuthorCollection>;
  contentfulMetadata: ContentfulMetadata;
  date: Maybe<Scalars['DateTime']>;
  featuredProductsCollection: Maybe<ArticlePageFeaturedProductsCollection>;
  image: Maybe<Asset>;
  linkedFrom: Maybe<ArticlePageLinkingCollections>;
  personalizedTextCollection: Maybe<ArticlePagePersonalizedTextCollection>;
  reviewerCollection: Maybe<ArticlePageReviewerCollection>;
  showDisclosure: Maybe<Scalars['Boolean']>;
  slug: Maybe<Scalars['String']>;
  sys: Sys;
  title: Maybe<Scalars['String']>;
};


/** An individual article on the Care Resources page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/articlePage) */
export type ArticlePageArticleBodyArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** An individual article on the Care Resources page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/articlePage) */
export type ArticlePageArticleDescriptionArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** An individual article on the Care Resources page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/articlePage) */
export type ArticlePageAuthorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** An individual article on the Care Resources page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/articlePage) */
export type ArticlePageDateArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** An individual article on the Care Resources page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/articlePage) */
export type ArticlePageFeaturedProductsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** An individual article on the Care Resources page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/articlePage) */
export type ArticlePageImageArgs = {
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


/** An individual article on the Care Resources page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/articlePage) */
export type ArticlePageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** An individual article on the Care Resources page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/articlePage) */
export type ArticlePagePersonalizedTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** An individual article on the Care Resources page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/articlePage) */
export type ArticlePageReviewerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** An individual article on the Care Resources page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/articlePage) */
export type ArticlePageShowDisclosureArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** An individual article on the Care Resources page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/articlePage) */
export type ArticlePageSlugArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** An individual article on the Care Resources page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/articlePage) */
export type ArticlePageTitleArgs = {
  locale: InputMaybe<Scalars['String']>;
};

export type ArticlePageArticleBody = {
  __typename: 'ArticlePageArticleBody';
  json: Scalars['JSON'];
  links: ArticlePageArticleBodyLinks;
};

export type ArticlePageArticleBodyAssets = {
  __typename: 'ArticlePageArticleBodyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ArticlePageArticleBodyEntries = {
  __typename: 'ArticlePageArticleBodyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ArticlePageArticleBodyLinks = {
  __typename: 'ArticlePageArticleBodyLinks';
  assets: ArticlePageArticleBodyAssets;
  entries: ArticlePageArticleBodyEntries;
};

export type ArticlePageArticleDescription = {
  __typename: 'ArticlePageArticleDescription';
  json: Scalars['JSON'];
  links: ArticlePageArticleDescriptionLinks;
};

export type ArticlePageArticleDescriptionAssets = {
  __typename: 'ArticlePageArticleDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ArticlePageArticleDescriptionEntries = {
  __typename: 'ArticlePageArticleDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ArticlePageArticleDescriptionLinks = {
  __typename: 'ArticlePageArticleDescriptionLinks';
  assets: ArticlePageArticleDescriptionAssets;
  entries: ArticlePageArticleDescriptionEntries;
};

export type ArticlePageAuthorCollection = {
  __typename: 'ArticlePageAuthorCollection';
  items: Array<Maybe<Person>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ArticlePageCollection = {
  __typename: 'ArticlePageCollection';
  items: Array<Maybe<ArticlePage>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ArticlePageFeaturedProductsCollection = {
  __typename: 'ArticlePageFeaturedProductsCollection';
  items: Array<Maybe<ArticlePageFeaturedProductsItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ArticlePageFeaturedProductsItem = CareResourcesLink | CareResourcesProduct;

export type ArticlePageFilter = {
  AND?: InputMaybe<Array<InputMaybe<ArticlePageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ArticlePageFilter>>>;
  articleBody_contains?: InputMaybe<Scalars['String']>;
  articleBody_exists?: InputMaybe<Scalars['Boolean']>;
  articleBody_not_contains?: InputMaybe<Scalars['String']>;
  articleDescription_contains?: InputMaybe<Scalars['String']>;
  articleDescription_exists?: InputMaybe<Scalars['Boolean']>;
  articleDescription_not_contains?: InputMaybe<Scalars['String']>;
  author?: InputMaybe<CfPersonNestedFilter>;
  authorCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  date?: InputMaybe<Scalars['DateTime']>;
  date_exists?: InputMaybe<Scalars['Boolean']>;
  date_gt?: InputMaybe<Scalars['DateTime']>;
  date_gte?: InputMaybe<Scalars['DateTime']>;
  date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  date_lt?: InputMaybe<Scalars['DateTime']>;
  date_lte?: InputMaybe<Scalars['DateTime']>;
  date_not?: InputMaybe<Scalars['DateTime']>;
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  featuredProductsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  personalizedText?: InputMaybe<CfCareResourcesArticlePersonalizedTextNestedFilter>;
  personalizedTextCollection_exists?: InputMaybe<Scalars['Boolean']>;
  reviewer?: InputMaybe<CfPersonNestedFilter>;
  reviewerCollection_exists?: InputMaybe<Scalars['Boolean']>;
  showDisclosure?: InputMaybe<Scalars['Boolean']>;
  showDisclosure_exists?: InputMaybe<Scalars['Boolean']>;
  showDisclosure_not?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  slug_contains?: InputMaybe<Scalars['String']>;
  slug_exists?: InputMaybe<Scalars['Boolean']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug_not?: InputMaybe<Scalars['String']>;
  slug_not_contains?: InputMaybe<Scalars['String']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ArticlePageLinkingCollections = {
  __typename: 'ArticlePageLinkingCollections';
  careResourcesSectionCollection: Maybe<CareResourcesSectionCollection>;
  entryCollection: Maybe<EntryCollection>;
};


export type ArticlePageLinkingCollectionsCareResourcesSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ArticlePageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ArticlePageOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ShowDisclosureAsc = 'showDisclosure_ASC',
  ShowDisclosureDesc = 'showDisclosure_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ArticlePagePersonalizedTextCollection = {
  __typename: 'ArticlePagePersonalizedTextCollection';
  items: Array<Maybe<CareResourcesArticlePersonalizedText>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ArticlePageReviewerCollection = {
  __typename: 'ArticlePageReviewerCollection';
  items: Array<Maybe<Person>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

/** Represents a binary file in a space. An asset can be any file type. */
export type Asset = {
  __typename: 'Asset';
  contentType: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<Scalars['String']>;
  fileName: Maybe<Scalars['String']>;
  height: Maybe<Scalars['Int']>;
  linkedFrom: Maybe<AssetLinkingCollections>;
  size: Maybe<Scalars['Int']>;
  sys: Sys;
  title: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
  width: Maybe<Scalars['Int']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetContentTypeArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetDescriptionArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetFileNameArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetHeightArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetSizeArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetTitleArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetUrlArgs = {
  locale: InputMaybe<Scalars['String']>;
  transform: InputMaybe<ImageTransformOptions>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetWidthArgs = {
  locale: InputMaybe<Scalars['String']>;
};

export type AssetCollection = {
  __typename: 'AssetCollection';
  items: Array<Maybe<Asset>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type AssetFilter = {
  AND?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  contentType?: InputMaybe<Scalars['String']>;
  contentType_contains?: InputMaybe<Scalars['String']>;
  contentType_exists?: InputMaybe<Scalars['Boolean']>;
  contentType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentType_not?: InputMaybe<Scalars['String']>;
  contentType_not_contains?: InputMaybe<Scalars['String']>;
  contentType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fileName?: InputMaybe<Scalars['String']>;
  fileName_contains?: InputMaybe<Scalars['String']>;
  fileName_exists?: InputMaybe<Scalars['Boolean']>;
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fileName_not?: InputMaybe<Scalars['String']>;
  fileName_not_contains?: InputMaybe<Scalars['String']>;
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  height?: InputMaybe<Scalars['Int']>;
  height_exists?: InputMaybe<Scalars['Boolean']>;
  height_gt?: InputMaybe<Scalars['Int']>;
  height_gte?: InputMaybe<Scalars['Int']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  height_lt?: InputMaybe<Scalars['Int']>;
  height_lte?: InputMaybe<Scalars['Int']>;
  height_not?: InputMaybe<Scalars['Int']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  size?: InputMaybe<Scalars['Int']>;
  size_exists?: InputMaybe<Scalars['Boolean']>;
  size_gt?: InputMaybe<Scalars['Int']>;
  size_gte?: InputMaybe<Scalars['Int']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  size_lt?: InputMaybe<Scalars['Int']>;
  size_lte?: InputMaybe<Scalars['Int']>;
  size_not?: InputMaybe<Scalars['Int']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  url_contains?: InputMaybe<Scalars['String']>;
  url_exists?: InputMaybe<Scalars['Boolean']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url_not?: InputMaybe<Scalars['String']>;
  url_not_contains?: InputMaybe<Scalars['String']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  width?: InputMaybe<Scalars['Int']>;
  width_exists?: InputMaybe<Scalars['Boolean']>;
  width_gt?: InputMaybe<Scalars['Int']>;
  width_gte?: InputMaybe<Scalars['Int']>;
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  width_lt?: InputMaybe<Scalars['Int']>;
  width_lte?: InputMaybe<Scalars['Int']>;
  width_not?: InputMaybe<Scalars['Int']>;
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type AssetLinkingCollections = {
  __typename: 'AssetLinkingCollections';
  articlePageCollection: Maybe<ArticlePageCollection>;
  careResourcesLinkCollection: Maybe<CareResourcesLinkCollection>;
  careResourcesProductCollection: Maybe<CareResourcesProductCollection>;
  entryCollection: Maybe<EntryCollection>;
};


export type AssetLinkingCollectionsArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsCareResourcesLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsCareResourcesProductCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum AssetOrder {
  ContentTypeAsc = 'contentType_ASC',
  ContentTypeDesc = 'contentType_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

/**
 * Personalized text on the Care Resources Article Page that explains why this text is showing up for the users dog.
 *
 * E.x. if the dog has the trait for high motivation we mention that above the recommended products. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesArticlePersonalizedText)
 */
export type CareResourcesArticlePersonalizedText = Entry & {
  __typename: 'CareResourcesArticlePersonalizedText';
  category: Maybe<CareResourcesCategory>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<CareResourcesArticlePersonalizedTextLinkingCollections>;
  personalizedText: Maybe<CareResourcesArticlePersonalizedTextPersonalizedText>;
  reason: Maybe<CareResourcesReason>;
  sys: Sys;
  title: Maybe<Scalars['String']>;
};


/**
 * Personalized text on the Care Resources Article Page that explains why this text is showing up for the users dog.
 *
 * E.x. if the dog has the trait for high motivation we mention that above the recommended products. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesArticlePersonalizedText)
 */
export type CareResourcesArticlePersonalizedTextCategoryArgs = {
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


/**
 * Personalized text on the Care Resources Article Page that explains why this text is showing up for the users dog.
 *
 * E.x. if the dog has the trait for high motivation we mention that above the recommended products. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesArticlePersonalizedText)
 */
export type CareResourcesArticlePersonalizedTextLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/**
 * Personalized text on the Care Resources Article Page that explains why this text is showing up for the users dog.
 *
 * E.x. if the dog has the trait for high motivation we mention that above the recommended products. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesArticlePersonalizedText)
 */
export type CareResourcesArticlePersonalizedTextPersonalizedTextArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/**
 * Personalized text on the Care Resources Article Page that explains why this text is showing up for the users dog.
 *
 * E.x. if the dog has the trait for high motivation we mention that above the recommended products. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesArticlePersonalizedText)
 */
export type CareResourcesArticlePersonalizedTextReasonArgs = {
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


/**
 * Personalized text on the Care Resources Article Page that explains why this text is showing up for the users dog.
 *
 * E.x. if the dog has the trait for high motivation we mention that above the recommended products. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesArticlePersonalizedText)
 */
export type CareResourcesArticlePersonalizedTextTitleArgs = {
  locale: InputMaybe<Scalars['String']>;
};

export type CareResourcesArticlePersonalizedTextCollection = {
  __typename: 'CareResourcesArticlePersonalizedTextCollection';
  items: Array<Maybe<CareResourcesArticlePersonalizedText>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CareResourcesArticlePersonalizedTextFilter = {
  AND?: InputMaybe<Array<InputMaybe<CareResourcesArticlePersonalizedTextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CareResourcesArticlePersonalizedTextFilter>>>;
  category?: InputMaybe<CfCareResourcesCategoryNestedFilter>;
  category_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  personalizedText_contains?: InputMaybe<Scalars['String']>;
  personalizedText_exists?: InputMaybe<Scalars['Boolean']>;
  personalizedText_not_contains?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<CfCareResourcesReasonNestedFilter>;
  reason_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CareResourcesArticlePersonalizedTextLinkingCollections = {
  __typename: 'CareResourcesArticlePersonalizedTextLinkingCollections';
  articlePageCollection: Maybe<ArticlePageCollection>;
  entryCollection: Maybe<EntryCollection>;
};


export type CareResourcesArticlePersonalizedTextLinkingCollectionsArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CareResourcesArticlePersonalizedTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CareResourcesArticlePersonalizedTextOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CareResourcesArticlePersonalizedTextPersonalizedText = {
  __typename: 'CareResourcesArticlePersonalizedTextPersonalizedText';
  json: Scalars['JSON'];
  links: CareResourcesArticlePersonalizedTextPersonalizedTextLinks;
};

export type CareResourcesArticlePersonalizedTextPersonalizedTextAssets = {
  __typename: 'CareResourcesArticlePersonalizedTextPersonalizedTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type CareResourcesArticlePersonalizedTextPersonalizedTextEntries = {
  __typename: 'CareResourcesArticlePersonalizedTextPersonalizedTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type CareResourcesArticlePersonalizedTextPersonalizedTextLinks = {
  __typename: 'CareResourcesArticlePersonalizedTextPersonalizedTextLinks';
  assets: CareResourcesArticlePersonalizedTextPersonalizedTextAssets;
  entries: CareResourcesArticlePersonalizedTextPersonalizedTextEntries;
};

/** A category on the Care Resources page [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesCategory) */
export type CareResourcesCategory = Entry & {
  __typename: 'CareResourcesCategory';
  contentfulMetadata: ContentfulMetadata;
  darkColor: Maybe<Scalars['String']>;
  emojiCode: Maybe<Scalars['Int']>;
  lightColor: Maybe<Scalars['String']>;
  linkedFrom: Maybe<CareResourcesCategoryLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']>;
};


/** A category on the Care Resources page [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesCategory) */
export type CareResourcesCategoryDarkColorArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** A category on the Care Resources page [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesCategory) */
export type CareResourcesCategoryEmojiCodeArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** A category on the Care Resources page [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesCategory) */
export type CareResourcesCategoryLightColorArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** A category on the Care Resources page [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesCategory) */
export type CareResourcesCategoryLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** A category on the Care Resources page [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesCategory) */
export type CareResourcesCategoryTitleArgs = {
  locale: InputMaybe<Scalars['String']>;
};

export type CareResourcesCategoryCollection = {
  __typename: 'CareResourcesCategoryCollection';
  items: Array<Maybe<CareResourcesCategory>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CareResourcesCategoryFilter = {
  AND?: InputMaybe<Array<InputMaybe<CareResourcesCategoryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CareResourcesCategoryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  darkColor?: InputMaybe<Scalars['String']>;
  darkColor_contains?: InputMaybe<Scalars['String']>;
  darkColor_exists?: InputMaybe<Scalars['Boolean']>;
  darkColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  darkColor_not?: InputMaybe<Scalars['String']>;
  darkColor_not_contains?: InputMaybe<Scalars['String']>;
  darkColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emojiCode?: InputMaybe<Scalars['Int']>;
  emojiCode_exists?: InputMaybe<Scalars['Boolean']>;
  emojiCode_gt?: InputMaybe<Scalars['Int']>;
  emojiCode_gte?: InputMaybe<Scalars['Int']>;
  emojiCode_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  emojiCode_lt?: InputMaybe<Scalars['Int']>;
  emojiCode_lte?: InputMaybe<Scalars['Int']>;
  emojiCode_not?: InputMaybe<Scalars['Int']>;
  emojiCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lightColor?: InputMaybe<Scalars['String']>;
  lightColor_contains?: InputMaybe<Scalars['String']>;
  lightColor_exists?: InputMaybe<Scalars['Boolean']>;
  lightColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lightColor_not?: InputMaybe<Scalars['String']>;
  lightColor_not_contains?: InputMaybe<Scalars['String']>;
  lightColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CareResourcesCategoryLinkingCollections = {
  __typename: 'CareResourcesCategoryLinkingCollections';
  careResourcesArticlePersonalizedTextCollection: Maybe<CareResourcesArticlePersonalizedTextCollection>;
  careResourcesSectionPersonalizedTextCollection: Maybe<CareResourcesSectionPersonalizedTextCollection>;
  entryCollection: Maybe<EntryCollection>;
};


export type CareResourcesCategoryLinkingCollectionsCareResourcesArticlePersonalizedTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CareResourcesCategoryLinkingCollectionsCareResourcesSectionPersonalizedTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CareResourcesCategoryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CareResourcesCategoryOrder {
  DarkColorAsc = 'darkColor_ASC',
  DarkColorDesc = 'darkColor_DESC',
  EmojiCodeAsc = 'emojiCode_ASC',
  EmojiCodeDesc = 'emojiCode_DESC',
  LightColorAsc = 'lightColor_ASC',
  LightColorDesc = 'lightColor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** Links to pages outside of Care Resources which will appear the same way as articles on the Summary page, but link to an external or internal page [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesLink) */
export type CareResourcesLink = Entry & {
  __typename: 'CareResourcesLink';
  contentfulMetadata: ContentfulMetadata;
  image: Maybe<Asset>;
  linkedFrom: Maybe<CareResourcesLinkLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};


/** Links to pages outside of Care Resources which will appear the same way as articles on the Summary page, but link to an external or internal page [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesLink) */
export type CareResourcesLinkImageArgs = {
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


/** Links to pages outside of Care Resources which will appear the same way as articles on the Summary page, but link to an external or internal page [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesLink) */
export type CareResourcesLinkLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Links to pages outside of Care Resources which will appear the same way as articles on the Summary page, but link to an external or internal page [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesLink) */
export type CareResourcesLinkTitleArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** Links to pages outside of Care Resources which will appear the same way as articles on the Summary page, but link to an external or internal page [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesLink) */
export type CareResourcesLinkUrlArgs = {
  locale: InputMaybe<Scalars['String']>;
};

export type CareResourcesLinkCollection = {
  __typename: 'CareResourcesLinkCollection';
  items: Array<Maybe<CareResourcesLink>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CareResourcesLinkFilter = {
  AND?: InputMaybe<Array<InputMaybe<CareResourcesLinkFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CareResourcesLinkFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  url_contains?: InputMaybe<Scalars['String']>;
  url_exists?: InputMaybe<Scalars['Boolean']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url_not?: InputMaybe<Scalars['String']>;
  url_not_contains?: InputMaybe<Scalars['String']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CareResourcesLinkLinkingCollections = {
  __typename: 'CareResourcesLinkLinkingCollections';
  articlePageCollection: Maybe<ArticlePageCollection>;
  careResourcesSectionCollection: Maybe<CareResourcesSectionCollection>;
  entryCollection: Maybe<EntryCollection>;
};


export type CareResourcesLinkLinkingCollectionsArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CareResourcesLinkLinkingCollectionsCareResourcesSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CareResourcesLinkLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CareResourcesLinkOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

/**
 * A product (in Amazon or some other seller) that we link to in the Care Resources tab.
 *
 * These products can be used inline in text or as a card that shows the product link, title, price, etc. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesProduct)
 */
export type CareResourcesProduct = Entry & {
  __typename: 'CareResourcesProduct';
  company: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<CareResourcesProductLinkingCollections>;
  name: Maybe<Scalars['String']>;
  price: Maybe<Scalars['Float']>;
  productDescription: Maybe<CareResourcesProductProductDescription>;
  productImage: Maybe<Asset>;
  store: Maybe<Scalars['String']>;
  sys: Sys;
  url: Maybe<Scalars['String']>;
};


/**
 * A product (in Amazon or some other seller) that we link to in the Care Resources tab.
 *
 * These products can be used inline in text or as a card that shows the product link, title, price, etc. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesProduct)
 */
export type CareResourcesProductCompanyArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/**
 * A product (in Amazon or some other seller) that we link to in the Care Resources tab.
 *
 * These products can be used inline in text or as a card that shows the product link, title, price, etc. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesProduct)
 */
export type CareResourcesProductLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/**
 * A product (in Amazon or some other seller) that we link to in the Care Resources tab.
 *
 * These products can be used inline in text or as a card that shows the product link, title, price, etc. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesProduct)
 */
export type CareResourcesProductNameArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/**
 * A product (in Amazon or some other seller) that we link to in the Care Resources tab.
 *
 * These products can be used inline in text or as a card that shows the product link, title, price, etc. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesProduct)
 */
export type CareResourcesProductPriceArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/**
 * A product (in Amazon or some other seller) that we link to in the Care Resources tab.
 *
 * These products can be used inline in text or as a card that shows the product link, title, price, etc. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesProduct)
 */
export type CareResourcesProductProductDescriptionArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/**
 * A product (in Amazon or some other seller) that we link to in the Care Resources tab.
 *
 * These products can be used inline in text or as a card that shows the product link, title, price, etc. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesProduct)
 */
export type CareResourcesProductProductImageArgs = {
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


/**
 * A product (in Amazon or some other seller) that we link to in the Care Resources tab.
 *
 * These products can be used inline in text or as a card that shows the product link, title, price, etc. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesProduct)
 */
export type CareResourcesProductStoreArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/**
 * A product (in Amazon or some other seller) that we link to in the Care Resources tab.
 *
 * These products can be used inline in text or as a card that shows the product link, title, price, etc. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesProduct)
 */
export type CareResourcesProductUrlArgs = {
  locale: InputMaybe<Scalars['String']>;
};

export type CareResourcesProductCollection = {
  __typename: 'CareResourcesProductCollection';
  items: Array<Maybe<CareResourcesProduct>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CareResourcesProductFilter = {
  AND?: InputMaybe<Array<InputMaybe<CareResourcesProductFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CareResourcesProductFilter>>>;
  company?: InputMaybe<Scalars['String']>;
  company_contains?: InputMaybe<Scalars['String']>;
  company_exists?: InputMaybe<Scalars['Boolean']>;
  company_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company_not?: InputMaybe<Scalars['String']>;
  company_not_contains?: InputMaybe<Scalars['String']>;
  company_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  price?: InputMaybe<Scalars['Float']>;
  price_exists?: InputMaybe<Scalars['Boolean']>;
  price_gt?: InputMaybe<Scalars['Float']>;
  price_gte?: InputMaybe<Scalars['Float']>;
  price_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  price_lt?: InputMaybe<Scalars['Float']>;
  price_lte?: InputMaybe<Scalars['Float']>;
  price_not?: InputMaybe<Scalars['Float']>;
  price_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  productDescription_contains?: InputMaybe<Scalars['String']>;
  productDescription_exists?: InputMaybe<Scalars['Boolean']>;
  productDescription_not_contains?: InputMaybe<Scalars['String']>;
  productImage_exists?: InputMaybe<Scalars['Boolean']>;
  store?: InputMaybe<Scalars['String']>;
  store_contains?: InputMaybe<Scalars['String']>;
  store_exists?: InputMaybe<Scalars['Boolean']>;
  store_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  store_not?: InputMaybe<Scalars['String']>;
  store_not_contains?: InputMaybe<Scalars['String']>;
  store_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  url?: InputMaybe<Scalars['String']>;
  url_contains?: InputMaybe<Scalars['String']>;
  url_exists?: InputMaybe<Scalars['Boolean']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url_not?: InputMaybe<Scalars['String']>;
  url_not_contains?: InputMaybe<Scalars['String']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CareResourcesProductLinkingCollections = {
  __typename: 'CareResourcesProductLinkingCollections';
  articlePageCollection: Maybe<ArticlePageCollection>;
  careResourcesSectionCollection: Maybe<CareResourcesSectionCollection>;
  entryCollection: Maybe<EntryCollection>;
};


export type CareResourcesProductLinkingCollectionsArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CareResourcesProductLinkingCollectionsCareResourcesSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CareResourcesProductLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CareResourcesProductOrder {
  CompanyAsc = 'company_ASC',
  CompanyDesc = 'company_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PriceAsc = 'price_ASC',
  PriceDesc = 'price_DESC',
  StoreAsc = 'store_ASC',
  StoreDesc = 'store_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export type CareResourcesProductProductDescription = {
  __typename: 'CareResourcesProductProductDescription';
  json: Scalars['JSON'];
  links: CareResourcesProductProductDescriptionLinks;
};

export type CareResourcesProductProductDescriptionAssets = {
  __typename: 'CareResourcesProductProductDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type CareResourcesProductProductDescriptionEntries = {
  __typename: 'CareResourcesProductProductDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type CareResourcesProductProductDescriptionLinks = {
  __typename: 'CareResourcesProductProductDescriptionLinks';
  assets: CareResourcesProductProductDescriptionAssets;
  entries: CareResourcesProductProductDescriptionEntries;
};

/** A reason for displaying a Care Resources section on the Care Resources summary page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesReason) */
export type CareResourcesReason = Entry & {
  __typename: 'CareResourcesReason';
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<CareResourcesReasonLinkingCollections>;
  reasonId: Maybe<Scalars['String']>;
  sys: Sys;
};


/** A reason for displaying a Care Resources section on the Care Resources summary page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesReason) */
export type CareResourcesReasonLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** A reason for displaying a Care Resources section on the Care Resources summary page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesReason) */
export type CareResourcesReasonReasonIdArgs = {
  locale: InputMaybe<Scalars['String']>;
};

export type CareResourcesReasonCollection = {
  __typename: 'CareResourcesReasonCollection';
  items: Array<Maybe<CareResourcesReason>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CareResourcesReasonFilter = {
  AND?: InputMaybe<Array<InputMaybe<CareResourcesReasonFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CareResourcesReasonFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  reasonId?: InputMaybe<Scalars['String']>;
  reasonId_contains?: InputMaybe<Scalars['String']>;
  reasonId_exists?: InputMaybe<Scalars['Boolean']>;
  reasonId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  reasonId_not?: InputMaybe<Scalars['String']>;
  reasonId_not_contains?: InputMaybe<Scalars['String']>;
  reasonId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CareResourcesReasonLinkingCollections = {
  __typename: 'CareResourcesReasonLinkingCollections';
  careResourcesArticlePersonalizedTextCollection: Maybe<CareResourcesArticlePersonalizedTextCollection>;
  careResourcesSectionPersonalizedTextCollection: Maybe<CareResourcesSectionPersonalizedTextCollection>;
  entryCollection: Maybe<EntryCollection>;
};


export type CareResourcesReasonLinkingCollectionsCareResourcesArticlePersonalizedTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CareResourcesReasonLinkingCollectionsCareResourcesSectionPersonalizedTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CareResourcesReasonLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CareResourcesReasonOrder {
  ReasonIdAsc = 'reasonId_ASC',
  ReasonIdDesc = 'reasonId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** A section within the Care Resources summary page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesSection) */
export type CareResourcesSection = Entry & {
  __typename: 'CareResourcesSection';
  contentfulMetadata: ContentfulMetadata;
  itemsCollection: Maybe<CareResourcesSectionItemsCollection>;
  linkedFrom: Maybe<CareResourcesSectionLinkingCollections>;
  personalizedTextCollection: Maybe<CareResourcesSectionPersonalizedTextCollection>;
  priority: Maybe<Scalars['Int']>;
  sectionId: Maybe<Scalars['String']>;
  sys: Sys;
  title: Maybe<Scalars['String']>;
};


/** A section within the Care Resources summary page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesSection) */
export type CareResourcesSectionItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** A section within the Care Resources summary page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesSection) */
export type CareResourcesSectionLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** A section within the Care Resources summary page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesSection) */
export type CareResourcesSectionPersonalizedTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** A section within the Care Resources summary page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesSection) */
export type CareResourcesSectionPriorityArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** A section within the Care Resources summary page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesSection) */
export type CareResourcesSectionSectionIdArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** A section within the Care Resources summary page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesSection) */
export type CareResourcesSectionTitleArgs = {
  locale: InputMaybe<Scalars['String']>;
};

export type CareResourcesSectionCollection = {
  __typename: 'CareResourcesSectionCollection';
  items: Array<Maybe<CareResourcesSection>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CareResourcesSectionFilter = {
  AND?: InputMaybe<Array<InputMaybe<CareResourcesSectionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CareResourcesSectionFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  itemsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  personalizedText?: InputMaybe<CfCareResourcesSectionPersonalizedTextNestedFilter>;
  personalizedTextCollection_exists?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  priority_exists?: InputMaybe<Scalars['Boolean']>;
  priority_gt?: InputMaybe<Scalars['Int']>;
  priority_gte?: InputMaybe<Scalars['Int']>;
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  priority_lt?: InputMaybe<Scalars['Int']>;
  priority_lte?: InputMaybe<Scalars['Int']>;
  priority_not?: InputMaybe<Scalars['Int']>;
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sectionId?: InputMaybe<Scalars['String']>;
  sectionId_contains?: InputMaybe<Scalars['String']>;
  sectionId_exists?: InputMaybe<Scalars['Boolean']>;
  sectionId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId_not?: InputMaybe<Scalars['String']>;
  sectionId_not_contains?: InputMaybe<Scalars['String']>;
  sectionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CareResourcesSectionItemsCollection = {
  __typename: 'CareResourcesSectionItemsCollection';
  items: Array<Maybe<CareResourcesSectionItemsItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CareResourcesSectionItemsItem = ArticlePage | CareResourcesLink | CareResourcesProduct;

export type CareResourcesSectionLinkingCollections = {
  __typename: 'CareResourcesSectionLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  healthConditionCollection: Maybe<HealthConditionCollection>;
};


export type CareResourcesSectionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CareResourcesSectionLinkingCollectionsHealthConditionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CareResourcesSectionOrder {
  PriorityAsc = 'priority_ASC',
  PriorityDesc = 'priority_DESC',
  SectionIdAsc = 'sectionId_ASC',
  SectionIdDesc = 'sectionId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** Personalized text in the Care Resources Section that explains why this section is showing up for the users dog. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesSectionPersonalizedText) */
export type CareResourcesSectionPersonalizedText = Entry & {
  __typename: 'CareResourcesSectionPersonalizedText';
  category: Maybe<CareResourcesCategory>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<CareResourcesSectionPersonalizedTextLinkingCollections>;
  personalizedText: Maybe<CareResourcesSectionPersonalizedTextPersonalizedText>;
  reason: Maybe<CareResourcesReason>;
  sys: Sys;
  title: Maybe<Scalars['String']>;
};


/** Personalized text in the Care Resources Section that explains why this section is showing up for the users dog. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesSectionPersonalizedText) */
export type CareResourcesSectionPersonalizedTextCategoryArgs = {
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


/** Personalized text in the Care Resources Section that explains why this section is showing up for the users dog. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesSectionPersonalizedText) */
export type CareResourcesSectionPersonalizedTextLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Personalized text in the Care Resources Section that explains why this section is showing up for the users dog. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesSectionPersonalizedText) */
export type CareResourcesSectionPersonalizedTextPersonalizedTextArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** Personalized text in the Care Resources Section that explains why this section is showing up for the users dog. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesSectionPersonalizedText) */
export type CareResourcesSectionPersonalizedTextReasonArgs = {
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


/** Personalized text in the Care Resources Section that explains why this section is showing up for the users dog. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/careResourcesSectionPersonalizedText) */
export type CareResourcesSectionPersonalizedTextTitleArgs = {
  locale: InputMaybe<Scalars['String']>;
};

export type CareResourcesSectionPersonalizedTextCollection = {
  __typename: 'CareResourcesSectionPersonalizedTextCollection';
  items: Array<Maybe<CareResourcesSectionPersonalizedText>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CareResourcesSectionPersonalizedTextFilter = {
  AND?: InputMaybe<Array<InputMaybe<CareResourcesSectionPersonalizedTextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CareResourcesSectionPersonalizedTextFilter>>>;
  category?: InputMaybe<CfCareResourcesCategoryNestedFilter>;
  category_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  personalizedText_contains?: InputMaybe<Scalars['String']>;
  personalizedText_exists?: InputMaybe<Scalars['Boolean']>;
  personalizedText_not_contains?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<CfCareResourcesReasonNestedFilter>;
  reason_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CareResourcesSectionPersonalizedTextLinkingCollections = {
  __typename: 'CareResourcesSectionPersonalizedTextLinkingCollections';
  careResourcesSectionCollection: Maybe<CareResourcesSectionCollection>;
  entryCollection: Maybe<EntryCollection>;
};


export type CareResourcesSectionPersonalizedTextLinkingCollectionsCareResourcesSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CareResourcesSectionPersonalizedTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CareResourcesSectionPersonalizedTextOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CareResourcesSectionPersonalizedTextPersonalizedText = {
  __typename: 'CareResourcesSectionPersonalizedTextPersonalizedText';
  json: Scalars['JSON'];
  links: CareResourcesSectionPersonalizedTextPersonalizedTextLinks;
};

export type CareResourcesSectionPersonalizedTextPersonalizedTextAssets = {
  __typename: 'CareResourcesSectionPersonalizedTextPersonalizedTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type CareResourcesSectionPersonalizedTextPersonalizedTextEntries = {
  __typename: 'CareResourcesSectionPersonalizedTextPersonalizedTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type CareResourcesSectionPersonalizedTextPersonalizedTextLinks = {
  __typename: 'CareResourcesSectionPersonalizedTextPersonalizedTextLinks';
  assets: CareResourcesSectionPersonalizedTextPersonalizedTextAssets;
  entries: CareResourcesSectionPersonalizedTextPersonalizedTextEntries;
};

export type ContentfulMetadata = {
  __typename: 'ContentfulMetadata';
  tags: Array<Maybe<ContentfulTag>>;
};

export type ContentfulMetadataFilter = {
  tags?: InputMaybe<ContentfulMetadataTagsFilter>;
  tags_exists?: InputMaybe<Scalars['Boolean']>;
};

export type ContentfulMetadataTagsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *     Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type ContentfulTag = {
  __typename: 'ContentfulTag';
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export type Entry = {
  contentfulMetadata: ContentfulMetadata;
  sys: Sys;
};

export type EntryCollection = {
  __typename: 'EntryCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type EntryFilter = {
  AND?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export enum EntryOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Content related to an Embark tested health condition. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/healthCondition) */
export type HealthCondition = Entry & {
  __typename: 'HealthCondition';
  careResourcesSectionsCollection: Maybe<HealthConditionCareResourcesSectionsCollection>;
  contentfulMetadata: ContentfulMetadata;
  id: Maybe<Scalars['String']>;
  linkedFrom: Maybe<HealthConditionLinkingCollections>;
  name: Maybe<Scalars['String']>;
  sys: Sys;
};


/** Content related to an Embark tested health condition. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/healthCondition) */
export type HealthConditionCareResourcesSectionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** Content related to an Embark tested health condition. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/healthCondition) */
export type HealthConditionIdArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** Content related to an Embark tested health condition. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/healthCondition) */
export type HealthConditionLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Content related to an Embark tested health condition. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/healthCondition) */
export type HealthConditionNameArgs = {
  locale: InputMaybe<Scalars['String']>;
};

export type HealthConditionCareResourcesSectionsCollection = {
  __typename: 'HealthConditionCareResourcesSectionsCollection';
  items: Array<Maybe<CareResourcesSection>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type HealthConditionCollection = {
  __typename: 'HealthConditionCollection';
  items: Array<Maybe<HealthCondition>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type HealthConditionFilter = {
  AND?: InputMaybe<Array<InputMaybe<HealthConditionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HealthConditionFilter>>>;
  careResourcesSections?: InputMaybe<CfCareResourcesSectionNestedFilter>;
  careResourcesSectionsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_exists?: InputMaybe<Scalars['Boolean']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type HealthConditionLinkingCollections = {
  __typename: 'HealthConditionLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
};


export type HealthConditionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum HealthConditionOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** The content for a polygenic condition details page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/hip_dysplasia_details) */
export type HipDysplasiaDetails = Entry & {
  __typename: 'HipDysplasiaDetails';
  conditionName: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<Scalars['String']>;
  linkedFrom: Maybe<HipDysplasiaDetailsLinkingCollections>;
  sys: Sys;
  whatDoesThisMeanForYourDog: Maybe<PolygenicConditionDetailsWhatDoesThisMean>;
};


/** The content for a polygenic condition details page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/hip_dysplasia_details) */
export type HipDysplasiaDetailsConditionNameArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** The content for a polygenic condition details page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/hip_dysplasia_details) */
export type HipDysplasiaDetailsDescriptionArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** The content for a polygenic condition details page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/hip_dysplasia_details) */
export type HipDysplasiaDetailsLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** The content for a polygenic condition details page. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/hip_dysplasia_details) */
export type HipDysplasiaDetailsWhatDoesThisMeanForYourDogArgs = {
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};

export type HipDysplasiaDetailsCollection = {
  __typename: 'HipDysplasiaDetailsCollection';
  items: Array<Maybe<HipDysplasiaDetails>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type HipDysplasiaDetailsFilter = {
  AND?: InputMaybe<Array<InputMaybe<HipDysplasiaDetailsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HipDysplasiaDetailsFilter>>>;
  conditionName?: InputMaybe<Scalars['String']>;
  conditionName_contains?: InputMaybe<Scalars['String']>;
  conditionName_exists?: InputMaybe<Scalars['Boolean']>;
  conditionName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  conditionName_not?: InputMaybe<Scalars['String']>;
  conditionName_not_contains?: InputMaybe<Scalars['String']>;
  conditionName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  whatDoesThisMeanForYourDog?: InputMaybe<CfPolygenicConditionDetailsWhatDoesThisMeanNestedFilter>;
  whatDoesThisMeanForYourDog_exists?: InputMaybe<Scalars['Boolean']>;
};

export type HipDysplasiaDetailsLinkingCollections = {
  __typename: 'HipDysplasiaDetailsLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
};


export type HipDysplasiaDetailsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum HipDysplasiaDetailsOrder {
  ConditionNameAsc = 'conditionName_ASC',
  ConditionNameDesc = 'conditionName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ImageFormat {
  Avif = 'AVIF',
  /** JPG image format. */
  Jpg = 'JPG',
  /**
   * Progressive JPG format stores multiple passes of an image in progressively higher detail.
   *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
   *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
   *         early as possible to make the layout look as designed.
   */
  JpgProgressive = 'JPG_PROGRESSIVE',
  /** PNG image format */
  Png = 'PNG',
  /**
   * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
   *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
   */
  Png8 = 'PNG8',
  /** WebP image format. */
  Webp = 'WEBP'
}

export enum ImageResizeFocus {
  /** Focus the resizing on the bottom. */
  Bottom = 'BOTTOM',
  /** Focus the resizing on the bottom left. */
  BottomLeft = 'BOTTOM_LEFT',
  /** Focus the resizing on the bottom right. */
  BottomRight = 'BOTTOM_RIGHT',
  /** Focus the resizing on the center. */
  Center = 'CENTER',
  /** Focus the resizing on the largest face. */
  Face = 'FACE',
  /** Focus the resizing on the area containing all the faces. */
  Faces = 'FACES',
  /** Focus the resizing on the left. */
  Left = 'LEFT',
  /** Focus the resizing on the right. */
  Right = 'RIGHT',
  /** Focus the resizing on the top. */
  Top = 'TOP',
  /** Focus the resizing on the top left. */
  TopLeft = 'TOP_LEFT',
  /** Focus the resizing on the top right. */
  TopRight = 'TOP_RIGHT'
}

export enum ImageResizeStrategy {
  /** Crops a part of the original image to fit into the specified dimensions. */
  Crop = 'CROP',
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  Fill = 'FILL',
  /** Resizes the image to fit into the specified dimensions. */
  Fit = 'FIT',
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   *         Uses desired background color as padding color.
   */
  Pad = 'PAD',
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  Scale = 'SCALE',
  /** Creates a thumbnail from the image. */
  Thumb = 'THUMB'
}

export type ImageTransformOptions = {
  /**
   * Desired background color, used with corner radius or `PAD` resize strategy.
   *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
   */
  backgroundColor?: InputMaybe<Scalars['HexColor']>;
  /**
   * Desired corner radius in pixels.
   *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
   *         Defaults to `0`. Uses desired background color as padding color,
   *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
   */
  cornerRadius?: InputMaybe<Scalars['Int']>;
  /** Desired image format. Defaults to the original image format. */
  format?: InputMaybe<ImageFormat>;
  /** Desired height in pixels. Defaults to the original image height. */
  height?: InputMaybe<Scalars['Dimension']>;
  /**
   * Desired quality of the image in percents.
   *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
   */
  quality?: InputMaybe<Scalars['Quality']>;
  /** Desired resize focus area. Defaults to `CENTER`. */
  resizeFocus?: InputMaybe<ImageResizeFocus>;
  /** Desired resize strategy. Defaults to `FIT`. */
  resizeStrategy?: InputMaybe<ImageResizeStrategy>;
  /** Desired width in pixels. Defaults to the original image width. */
  width?: InputMaybe<Scalars['Dimension']>;
};

/** Person contains the data for individuals that can be used to describe authors and, potentially, other roles. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/person) */
export type Person = Entry & {
  __typename: 'Person';
  contentfulMetadata: ContentfulMetadata;
  fullName: Maybe<Scalars['String']>;
  linkedFrom: Maybe<PersonLinkingCollections>;
  slug: Maybe<Scalars['String']>;
  sys: Sys;
};


/** Person contains the data for individuals that can be used to describe authors and, potentially, other roles. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/person) */
export type PersonFullNameArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** Person contains the data for individuals that can be used to describe authors and, potentially, other roles. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/person) */
export type PersonLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Person contains the data for individuals that can be used to describe authors and, potentially, other roles. [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/person) */
export type PersonSlugArgs = {
  locale: InputMaybe<Scalars['String']>;
};

export type PersonCollection = {
  __typename: 'PersonCollection';
  items: Array<Maybe<Person>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type PersonFilter = {
  AND?: InputMaybe<Array<InputMaybe<PersonFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PersonFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  fullName?: InputMaybe<Scalars['String']>;
  fullName_contains?: InputMaybe<Scalars['String']>;
  fullName_exists?: InputMaybe<Scalars['Boolean']>;
  fullName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullName_not?: InputMaybe<Scalars['String']>;
  fullName_not_contains?: InputMaybe<Scalars['String']>;
  fullName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slug_contains?: InputMaybe<Scalars['String']>;
  slug_exists?: InputMaybe<Scalars['Boolean']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug_not?: InputMaybe<Scalars['String']>;
  slug_not_contains?: InputMaybe<Scalars['String']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type PersonLinkingCollections = {
  __typename: 'PersonLinkingCollections';
  articlePageCollection: Maybe<ArticlePageCollection>;
  entryCollection: Maybe<EntryCollection>;
};


export type PersonLinkingCollectionsArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PersonLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum PersonOrder {
  FullNameAsc = 'fullName_ASC',
  FullNameDesc = 'fullName_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/**
 * The What Does This Mean for Your Dog section of the polygenic details screen:
 * https://www.figma.com/file/E7Y9Z94zEfoLp9s7pfHm5J/MyEV-Updates?node-id=2704%3A11299 [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/polygenicConditionDetailsWhatDoesThisMean)
 */
export type PolygenicConditionDetailsWhatDoesThisMean = Entry & {
  __typename: 'PolygenicConditionDetailsWhatDoesThisMean';
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<PolygenicConditionDetailsWhatDoesThisMeanLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']>;
};


/**
 * The What Does This Mean for Your Dog section of the polygenic details screen:
 * https://www.figma.com/file/E7Y9Z94zEfoLp9s7pfHm5J/MyEV-Updates?node-id=2704%3A11299 [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/polygenicConditionDetailsWhatDoesThisMean)
 */
export type PolygenicConditionDetailsWhatDoesThisMeanLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/**
 * The What Does This Mean for Your Dog section of the polygenic details screen:
 * https://www.figma.com/file/E7Y9Z94zEfoLp9s7pfHm5J/MyEV-Updates?node-id=2704%3A11299 [See type definition](https://app.contentful.com/spaces/h3quqh83c5kj/content_types/polygenicConditionDetailsWhatDoesThisMean)
 */
export type PolygenicConditionDetailsWhatDoesThisMeanTitleArgs = {
  locale: InputMaybe<Scalars['String']>;
};

export type PolygenicConditionDetailsWhatDoesThisMeanCollection = {
  __typename: 'PolygenicConditionDetailsWhatDoesThisMeanCollection';
  items: Array<Maybe<PolygenicConditionDetailsWhatDoesThisMean>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type PolygenicConditionDetailsWhatDoesThisMeanFilter = {
  AND?: InputMaybe<Array<InputMaybe<PolygenicConditionDetailsWhatDoesThisMeanFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PolygenicConditionDetailsWhatDoesThisMeanFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PolygenicConditionDetailsWhatDoesThisMeanLinkingCollections = {
  __typename: 'PolygenicConditionDetailsWhatDoesThisMeanLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  hipDysplasiaDetailsCollection: Maybe<HipDysplasiaDetailsCollection>;
};


export type PolygenicConditionDetailsWhatDoesThisMeanLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PolygenicConditionDetailsWhatDoesThisMeanLinkingCollectionsHipDysplasiaDetailsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum PolygenicConditionDetailsWhatDoesThisMeanOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type Query = {
  __typename: 'Query';
  articlePage: Maybe<ArticlePage>;
  articlePageCollection: Maybe<ArticlePageCollection>;
  asset: Maybe<Asset>;
  assetCollection: Maybe<AssetCollection>;
  careResourcesArticlePersonalizedText: Maybe<CareResourcesArticlePersonalizedText>;
  careResourcesArticlePersonalizedTextCollection: Maybe<CareResourcesArticlePersonalizedTextCollection>;
  careResourcesCategory: Maybe<CareResourcesCategory>;
  careResourcesCategoryCollection: Maybe<CareResourcesCategoryCollection>;
  careResourcesLink: Maybe<CareResourcesLink>;
  careResourcesLinkCollection: Maybe<CareResourcesLinkCollection>;
  careResourcesProduct: Maybe<CareResourcesProduct>;
  careResourcesProductCollection: Maybe<CareResourcesProductCollection>;
  careResourcesReason: Maybe<CareResourcesReason>;
  careResourcesReasonCollection: Maybe<CareResourcesReasonCollection>;
  careResourcesSection: Maybe<CareResourcesSection>;
  careResourcesSectionCollection: Maybe<CareResourcesSectionCollection>;
  careResourcesSectionPersonalizedText: Maybe<CareResourcesSectionPersonalizedText>;
  careResourcesSectionPersonalizedTextCollection: Maybe<CareResourcesSectionPersonalizedTextCollection>;
  entryCollection: Maybe<EntryCollection>;
  healthCondition: Maybe<HealthCondition>;
  healthConditionCollection: Maybe<HealthConditionCollection>;
  hipDysplasiaDetails: Maybe<HipDysplasiaDetails>;
  hipDysplasiaDetailsCollection: Maybe<HipDysplasiaDetailsCollection>;
  person: Maybe<Person>;
  personCollection: Maybe<PersonCollection>;
  polygenicConditionDetailsWhatDoesThisMean: Maybe<PolygenicConditionDetailsWhatDoesThisMean>;
  polygenicConditionDetailsWhatDoesThisMeanCollection: Maybe<PolygenicConditionDetailsWhatDoesThisMeanCollection>;
};


export type QueryArticlePageArgs = {
  id: Scalars['String'];
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


export type QueryArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<ArticlePageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<ArticlePageFilter>;
};


export type QueryAssetArgs = {
  id: Scalars['String'];
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


export type QueryAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<AssetFilter>;
};


export type QueryCareResourcesArticlePersonalizedTextArgs = {
  id: Scalars['String'];
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


export type QueryCareResourcesArticlePersonalizedTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<CareResourcesArticlePersonalizedTextOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<CareResourcesArticlePersonalizedTextFilter>;
};


export type QueryCareResourcesCategoryArgs = {
  id: Scalars['String'];
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


export type QueryCareResourcesCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<CareResourcesCategoryOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<CareResourcesCategoryFilter>;
};


export type QueryCareResourcesLinkArgs = {
  id: Scalars['String'];
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


export type QueryCareResourcesLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<CareResourcesLinkOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<CareResourcesLinkFilter>;
};


export type QueryCareResourcesProductArgs = {
  id: Scalars['String'];
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


export type QueryCareResourcesProductCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<CareResourcesProductOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<CareResourcesProductFilter>;
};


export type QueryCareResourcesReasonArgs = {
  id: Scalars['String'];
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


export type QueryCareResourcesReasonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<CareResourcesReasonOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<CareResourcesReasonFilter>;
};


export type QueryCareResourcesSectionArgs = {
  id: Scalars['String'];
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


export type QueryCareResourcesSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<CareResourcesSectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<CareResourcesSectionFilter>;
};


export type QueryCareResourcesSectionPersonalizedTextArgs = {
  id: Scalars['String'];
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


export type QueryCareResourcesSectionPersonalizedTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<CareResourcesSectionPersonalizedTextOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<CareResourcesSectionPersonalizedTextFilter>;
};


export type QueryEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<EntryFilter>;
};


export type QueryHealthConditionArgs = {
  id: Scalars['String'];
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


export type QueryHealthConditionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<HealthConditionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<HealthConditionFilter>;
};


export type QueryHipDysplasiaDetailsArgs = {
  id: Scalars['String'];
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


export type QueryHipDysplasiaDetailsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<HipDysplasiaDetailsOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<HipDysplasiaDetailsFilter>;
};


export type QueryPersonArgs = {
  id: Scalars['String'];
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


export type QueryPersonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<PersonOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<PersonFilter>;
};


export type QueryPolygenicConditionDetailsWhatDoesThisMeanArgs = {
  id: Scalars['String'];
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


export type QueryPolygenicConditionDetailsWhatDoesThisMeanCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<PolygenicConditionDetailsWhatDoesThisMeanOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<PolygenicConditionDetailsWhatDoesThisMeanFilter>;
};

export type Sys = {
  __typename: 'Sys';
  environmentId: Scalars['String'];
  firstPublishedAt: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  publishedAt: Maybe<Scalars['DateTime']>;
  publishedVersion: Maybe<Scalars['Int']>;
  spaceId: Scalars['String'];
};

export type SysFilter = {
  firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_exists?: InputMaybe<Scalars['Boolean']>;
  firstPublishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  firstPublishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_not?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_exists?: InputMaybe<Scalars['Boolean']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_exists?: InputMaybe<Scalars['Boolean']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedVersion?: InputMaybe<Scalars['Float']>;
  publishedVersion_exists?: InputMaybe<Scalars['Boolean']>;
  publishedVersion_gt?: InputMaybe<Scalars['Float']>;
  publishedVersion_gte?: InputMaybe<Scalars['Float']>;
  publishedVersion_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  publishedVersion_lt?: InputMaybe<Scalars['Float']>;
  publishedVersion_lte?: InputMaybe<Scalars['Float']>;
  publishedVersion_not?: InputMaybe<Scalars['Float']>;
  publishedVersion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type CfCareResourcesArticlePersonalizedTextNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCareResourcesArticlePersonalizedTextNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCareResourcesArticlePersonalizedTextNestedFilter>>>;
  category_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  personalizedText_contains?: InputMaybe<Scalars['String']>;
  personalizedText_exists?: InputMaybe<Scalars['Boolean']>;
  personalizedText_not_contains?: InputMaybe<Scalars['String']>;
  reason_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfCareResourcesCategoryNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCareResourcesCategoryNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCareResourcesCategoryNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  darkColor?: InputMaybe<Scalars['String']>;
  darkColor_contains?: InputMaybe<Scalars['String']>;
  darkColor_exists?: InputMaybe<Scalars['Boolean']>;
  darkColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  darkColor_not?: InputMaybe<Scalars['String']>;
  darkColor_not_contains?: InputMaybe<Scalars['String']>;
  darkColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emojiCode?: InputMaybe<Scalars['Int']>;
  emojiCode_exists?: InputMaybe<Scalars['Boolean']>;
  emojiCode_gt?: InputMaybe<Scalars['Int']>;
  emojiCode_gte?: InputMaybe<Scalars['Int']>;
  emojiCode_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  emojiCode_lt?: InputMaybe<Scalars['Int']>;
  emojiCode_lte?: InputMaybe<Scalars['Int']>;
  emojiCode_not?: InputMaybe<Scalars['Int']>;
  emojiCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lightColor?: InputMaybe<Scalars['String']>;
  lightColor_contains?: InputMaybe<Scalars['String']>;
  lightColor_exists?: InputMaybe<Scalars['Boolean']>;
  lightColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lightColor_not?: InputMaybe<Scalars['String']>;
  lightColor_not_contains?: InputMaybe<Scalars['String']>;
  lightColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfCareResourcesReasonNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCareResourcesReasonNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCareResourcesReasonNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  reasonId?: InputMaybe<Scalars['String']>;
  reasonId_contains?: InputMaybe<Scalars['String']>;
  reasonId_exists?: InputMaybe<Scalars['Boolean']>;
  reasonId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  reasonId_not?: InputMaybe<Scalars['String']>;
  reasonId_not_contains?: InputMaybe<Scalars['String']>;
  reasonId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfCareResourcesSectionNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCareResourcesSectionNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCareResourcesSectionNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  itemsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  personalizedTextCollection_exists?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  priority_exists?: InputMaybe<Scalars['Boolean']>;
  priority_gt?: InputMaybe<Scalars['Int']>;
  priority_gte?: InputMaybe<Scalars['Int']>;
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  priority_lt?: InputMaybe<Scalars['Int']>;
  priority_lte?: InputMaybe<Scalars['Int']>;
  priority_not?: InputMaybe<Scalars['Int']>;
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sectionId?: InputMaybe<Scalars['String']>;
  sectionId_contains?: InputMaybe<Scalars['String']>;
  sectionId_exists?: InputMaybe<Scalars['Boolean']>;
  sectionId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId_not?: InputMaybe<Scalars['String']>;
  sectionId_not_contains?: InputMaybe<Scalars['String']>;
  sectionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfCareResourcesSectionPersonalizedTextNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCareResourcesSectionPersonalizedTextNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCareResourcesSectionPersonalizedTextNestedFilter>>>;
  category_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  personalizedText_contains?: InputMaybe<Scalars['String']>;
  personalizedText_exists?: InputMaybe<Scalars['Boolean']>;
  personalizedText_not_contains?: InputMaybe<Scalars['String']>;
  reason_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfPersonNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPersonNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPersonNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  fullName?: InputMaybe<Scalars['String']>;
  fullName_contains?: InputMaybe<Scalars['String']>;
  fullName_exists?: InputMaybe<Scalars['Boolean']>;
  fullName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullName_not?: InputMaybe<Scalars['String']>;
  fullName_not_contains?: InputMaybe<Scalars['String']>;
  fullName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slug_contains?: InputMaybe<Scalars['String']>;
  slug_exists?: InputMaybe<Scalars['Boolean']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug_not?: InputMaybe<Scalars['String']>;
  slug_not_contains?: InputMaybe<Scalars['String']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfPolygenicConditionDetailsWhatDoesThisMeanNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPolygenicConditionDetailsWhatDoesThisMeanNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPolygenicConditionDetailsWhatDoesThisMeanNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GetCareResourcesArticleQueryVariables = Exact<{
  articleSlug: Scalars['String'];
}>;


export type GetCareResourcesArticleQuery = { __typename: 'Query', articlePageCollection: { __typename: 'ArticlePageCollection', items: Array<{ __typename: 'ArticlePage', slug: string | null, title: string | null, showDisclosure: boolean | null, date: string | null, image: { __typename: 'Asset', title: string | null, description: string | null, url: string | null } | null, authorCollection: { __typename: 'ArticlePageAuthorCollection', items: Array<{ __typename: 'Person', fullName: string | null } | null> } | null, reviewerCollection: { __typename: 'ArticlePageReviewerCollection', items: Array<{ __typename: 'Person', fullName: string | null } | null> } | null, articleDescription: { __typename: 'ArticlePageArticleDescription', json: any } | null, articleBody: { __typename: 'ArticlePageArticleBody', json: any, links: { __typename: 'ArticlePageArticleBodyLinks', entries: { __typename: 'ArticlePageArticleBodyEntries', hyperlink: Array<{ __typename: 'ArticlePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'CareResourcesArticlePersonalizedText', sys: { __typename: 'Sys', id: string } } | { __typename: 'CareResourcesCategory', sys: { __typename: 'Sys', id: string } } | { __typename: 'CareResourcesLink', sys: { __typename: 'Sys', id: string } } | { __typename: 'CareResourcesProduct', url: string | null, company: string | null, name: string | null, sys: { __typename: 'Sys', id: string } } | { __typename: 'CareResourcesReason', sys: { __typename: 'Sys', id: string } } | { __typename: 'CareResourcesSection', sys: { __typename: 'Sys', id: string } } | { __typename: 'CareResourcesSectionPersonalizedText', sys: { __typename: 'Sys', id: string } } | { __typename: 'HealthCondition', sys: { __typename: 'Sys', id: string } } | { __typename: 'HipDysplasiaDetails', sys: { __typename: 'Sys', id: string } } | { __typename: 'Person', sys: { __typename: 'Sys', id: string } } | { __typename: 'PolygenicConditionDetailsWhatDoesThisMean', sys: { __typename: 'Sys', id: string } } | null> }, assets: { __typename: 'ArticlePageArticleBodyAssets', block: Array<{ __typename: 'Asset', contentType: string | null, url: string | null, title: string | null, description: string | null, sys: { __typename: 'Sys', id: string } } | null> } } } | null, personalizedTextCollection: { __typename: 'ArticlePagePersonalizedTextCollection', items: Array<{ __typename: 'CareResourcesArticlePersonalizedText', personalizedText: { __typename: 'CareResourcesArticlePersonalizedTextPersonalizedText', json: any } | null, reason: { __typename: 'CareResourcesReason', reasonId: string | null } | null, category: { __typename: 'CareResourcesCategory', lightColor: string | null } | null } | null> } | null, featuredProductsCollection: { __typename: 'ArticlePageFeaturedProductsCollection', items: Array<{ __typename: 'CareResourcesLink', title: string | null, url: string | null, image: { __typename: 'Asset', url: string | null } | null } | { __typename: 'CareResourcesProduct', name: string | null, company: string | null, url: string | null, store: string | null, price: number | null, productImage: { __typename: 'Asset', url: string | null } | null, productDescription: { __typename: 'CareResourcesProductProductDescription', json: any } | null } | null> } | null } | null> } | null };

export type ContentfulArticleFragment = { __typename: 'ArticlePage', slug: string | null, title: string | null, showDisclosure: boolean | null, date: string | null, image: { __typename: 'Asset', title: string | null, description: string | null, url: string | null } | null, authorCollection: { __typename: 'ArticlePageAuthorCollection', items: Array<{ __typename: 'Person', fullName: string | null } | null> } | null, reviewerCollection: { __typename: 'ArticlePageReviewerCollection', items: Array<{ __typename: 'Person', fullName: string | null } | null> } | null, articleDescription: { __typename: 'ArticlePageArticleDescription', json: any } | null, articleBody: { __typename: 'ArticlePageArticleBody', json: any, links: { __typename: 'ArticlePageArticleBodyLinks', entries: { __typename: 'ArticlePageArticleBodyEntries', hyperlink: Array<{ __typename: 'ArticlePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'CareResourcesArticlePersonalizedText', sys: { __typename: 'Sys', id: string } } | { __typename: 'CareResourcesCategory', sys: { __typename: 'Sys', id: string } } | { __typename: 'CareResourcesLink', sys: { __typename: 'Sys', id: string } } | { __typename: 'CareResourcesProduct', url: string | null, company: string | null, name: string | null, sys: { __typename: 'Sys', id: string } } | { __typename: 'CareResourcesReason', sys: { __typename: 'Sys', id: string } } | { __typename: 'CareResourcesSection', sys: { __typename: 'Sys', id: string } } | { __typename: 'CareResourcesSectionPersonalizedText', sys: { __typename: 'Sys', id: string } } | { __typename: 'HealthCondition', sys: { __typename: 'Sys', id: string } } | { __typename: 'HipDysplasiaDetails', sys: { __typename: 'Sys', id: string } } | { __typename: 'Person', sys: { __typename: 'Sys', id: string } } | { __typename: 'PolygenicConditionDetailsWhatDoesThisMean', sys: { __typename: 'Sys', id: string } } | null> }, assets: { __typename: 'ArticlePageArticleBodyAssets', block: Array<{ __typename: 'Asset', contentType: string | null, url: string | null, title: string | null, description: string | null, sys: { __typename: 'Sys', id: string } } | null> } } } | null, personalizedTextCollection: { __typename: 'ArticlePagePersonalizedTextCollection', items: Array<{ __typename: 'CareResourcesArticlePersonalizedText', personalizedText: { __typename: 'CareResourcesArticlePersonalizedTextPersonalizedText', json: any } | null, reason: { __typename: 'CareResourcesReason', reasonId: string | null } | null, category: { __typename: 'CareResourcesCategory', lightColor: string | null } | null } | null> } | null, featuredProductsCollection: { __typename: 'ArticlePageFeaturedProductsCollection', items: Array<{ __typename: 'CareResourcesLink', title: string | null, url: string | null, image: { __typename: 'Asset', url: string | null } | null } | { __typename: 'CareResourcesProduct', name: string | null, company: string | null, url: string | null, store: string | null, price: number | null, productImage: { __typename: 'Asset', url: string | null } | null, productDescription: { __typename: 'CareResourcesProductProductDescription', json: any } | null } | null> } | null };

export type ContentfulArticleProductFragment = { __typename: 'CareResourcesProduct', url: string | null, company: string | null, name: string | null };

export type GetCareResourcesSummaryQueryVariables = Exact<{
  sectionIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetCareResourcesSummaryQuery = { __typename: 'Query', careResourcesSectionCollection: { __typename: 'CareResourcesSectionCollection', items: Array<{ __typename: 'CareResourcesSection', sectionId: string | null, title: string | null, priority: number | null, itemsCollection: { __typename: 'CareResourcesSectionItemsCollection', items: Array<{ __typename: 'ArticlePage', title: string | null, slug: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null } | null } | { __typename: 'CareResourcesLink', title: string | null, url: string | null, image: { __typename: 'Asset', url: string | null } | null } | { __typename: 'CareResourcesProduct', name: string | null, company: string | null, url: string | null, store: string | null, price: number | null, productImage: { __typename: 'Asset', url: string | null } | null, productDescription: { __typename: 'CareResourcesProductProductDescription', json: any } | null } | null> } | null, personalizedTextCollection: { __typename: 'CareResourcesSectionPersonalizedTextCollection', items: Array<{ __typename: 'CareResourcesSectionPersonalizedText', reason: { __typename: 'CareResourcesReason', reasonId: string | null } | null, personalizedText: { __typename: 'CareResourcesSectionPersonalizedTextPersonalizedText', json: any } | null, category: { __typename: 'CareResourcesCategory', title: string | null, emojiCode: number | null, darkColor: string | null } | null } | null> } | null } | null> } | null };

export type ContentfulSectionFragment = { __typename: 'CareResourcesSection', sectionId: string | null, title: string | null, priority: number | null, itemsCollection: { __typename: 'CareResourcesSectionItemsCollection', items: Array<{ __typename: 'ArticlePage', title: string | null, slug: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null } | null } | { __typename: 'CareResourcesLink', title: string | null, url: string | null, image: { __typename: 'Asset', url: string | null } | null } | { __typename: 'CareResourcesProduct', name: string | null, company: string | null, url: string | null, store: string | null, price: number | null, productImage: { __typename: 'Asset', url: string | null } | null, productDescription: { __typename: 'CareResourcesProductProductDescription', json: any } | null } | null> } | null, personalizedTextCollection: { __typename: 'CareResourcesSectionPersonalizedTextCollection', items: Array<{ __typename: 'CareResourcesSectionPersonalizedText', reason: { __typename: 'CareResourcesReason', reasonId: string | null } | null, personalizedText: { __typename: 'CareResourcesSectionPersonalizedTextPersonalizedText', json: any } | null, category: { __typename: 'CareResourcesCategory', title: string | null, emojiCode: number | null, darkColor: string | null } | null } | null> } | null };

export type ContentfulSectionPersonalizedTextFragment = { __typename: 'CareResourcesSectionPersonalizedText', reason: { __typename: 'CareResourcesReason', reasonId: string | null } | null, personalizedText: { __typename: 'CareResourcesSectionPersonalizedTextPersonalizedText', json: any } | null, category: { __typename: 'CareResourcesCategory', title: string | null, emojiCode: number | null, darkColor: string | null } | null };

export type ContentfulCategoryFragment = { __typename: 'CareResourcesCategory', title: string | null, emojiCode: number | null, darkColor: string | null };

export type ContentfulAssetFragment = { __typename: 'Asset', contentType: string | null, url: string | null, title: string | null, description: string | null, sys: { __typename: 'Sys', id: string } };

export type GetSectionForHealthConditionQueryVariables = Exact<{
  conditionId: Scalars['String'];
}>;


export type GetSectionForHealthConditionQuery = { __typename: 'Query', healthConditionCollection: { __typename: 'HealthConditionCollection', items: Array<{ __typename: 'HealthCondition', careResourcesSectionsCollection: { __typename: 'HealthConditionCareResourcesSectionsCollection', items: Array<{ __typename: 'CareResourcesSection', sectionId: string | null, title: string | null, priority: number | null, itemsCollection: { __typename: 'CareResourcesSectionItemsCollection', items: Array<{ __typename: 'ArticlePage', title: string | null, slug: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null } | null } | { __typename: 'CareResourcesLink', title: string | null, url: string | null, image: { __typename: 'Asset', url: string | null } | null } | { __typename: 'CareResourcesProduct', name: string | null, company: string | null, url: string | null, store: string | null, price: number | null, productImage: { __typename: 'Asset', url: string | null } | null, productDescription: { __typename: 'CareResourcesProductProductDescription', json: any } | null } | null> } | null, personalizedTextCollection: { __typename: 'CareResourcesSectionPersonalizedTextCollection', items: Array<{ __typename: 'CareResourcesSectionPersonalizedText', reason: { __typename: 'CareResourcesReason', reasonId: string | null } | null, personalizedText: { __typename: 'CareResourcesSectionPersonalizedTextPersonalizedText', json: any } | null, category: { __typename: 'CareResourcesCategory', title: string | null, emojiCode: number | null, darkColor: string | null } | null } | null> } | null } | null> } | null } | null> } | null };

export type CareResourcesArticleLinkFragment = { __typename: 'ArticlePage', title: string | null, slug: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null } | null };

export type CareResourcesOtherLinkFragment = { __typename: 'CareResourcesLink', title: string | null, url: string | null, image: { __typename: 'Asset', url: string | null } | null };

export type CareResourcesPersonalizationCardFragment = { __typename: 'ArticlePage', personalizedTextCollection: { __typename: 'ArticlePagePersonalizedTextCollection', items: Array<{ __typename: 'CareResourcesArticlePersonalizedText', personalizedText: { __typename: 'CareResourcesArticlePersonalizedTextPersonalizedText', json: any } | null, reason: { __typename: 'CareResourcesReason', reasonId: string | null } | null, category: { __typename: 'CareResourcesCategory', lightColor: string | null } | null } | null> } | null, featuredProductsCollection: { __typename: 'ArticlePageFeaturedProductsCollection', items: Array<{ __typename: 'CareResourcesLink', title: string | null, url: string | null, image: { __typename: 'Asset', url: string | null } | null } | { __typename: 'CareResourcesProduct', name: string | null, company: string | null, url: string | null, store: string | null, price: number | null, productImage: { __typename: 'Asset', url: string | null } | null, productDescription: { __typename: 'CareResourcesProductProductDescription', json: any } | null } | null> } | null };

export type CareResourcesPersonalizationCardReasonFragment = { __typename: 'CareResourcesArticlePersonalizedText', personalizedText: { __typename: 'CareResourcesArticlePersonalizedTextPersonalizedText', json: any } | null, reason: { __typename: 'CareResourcesReason', reasonId: string | null } | null, category: { __typename: 'CareResourcesCategory', lightColor: string | null } | null };

export type CareResourcesProductFragment = { __typename: 'CareResourcesProduct', name: string | null, company: string | null, url: string | null, store: string | null, price: number | null, productImage: { __typename: 'Asset', url: string | null } | null, productDescription: { __typename: 'CareResourcesProductProductDescription', json: any } | null };

export const CareResourcesPersonalizationCardReasonFragmentDoc = gql`
    fragment CareResourcesPersonalizationCardReasonFragment on CareResourcesArticlePersonalizedText {
  personalizedText {
    json
  }
  reason {
    reasonId
  }
  category {
    lightColor
  }
}
    `;
export const CareResourcesProductFragmentDoc = gql`
    fragment CareResourcesProductFragment on CareResourcesProduct {
  name
  company
  url
  store
  productImage {
    url
  }
  productDescription {
    json
  }
  price
  company
}
    `;
export const CareResourcesOtherLinkFragmentDoc = gql`
    fragment CareResourcesOtherLinkFragment on CareResourcesLink {
  title
  url
  image {
    url
  }
}
    `;
export const CareResourcesPersonalizationCardFragmentDoc = gql`
    fragment CareResourcesPersonalizationCardFragment on ArticlePage {
  personalizedTextCollection(limit: 10) {
    items {
      ...CareResourcesPersonalizationCardReasonFragment
    }
  }
  featuredProductsCollection(limit: 50) {
    items {
      ...CareResourcesProductFragment
      ...CareResourcesOtherLinkFragment
    }
  }
}
    ${CareResourcesPersonalizationCardReasonFragmentDoc}
${CareResourcesProductFragmentDoc}
${CareResourcesOtherLinkFragmentDoc}`;
export const ContentfulArticleProductFragmentDoc = gql`
    fragment ContentfulArticleProductFragment on CareResourcesProduct {
  url
  company
  name
}
    `;
export const ContentfulAssetFragmentDoc = gql`
    fragment ContentfulAssetFragment on Asset {
  sys {
    id
  }
  contentType
  url
  title
  description
}
    `;
export const ContentfulArticleFragmentDoc = gql`
    fragment ContentfulArticleFragment on ArticlePage {
  slug
  title
  showDisclosure
  image {
    title
    description
    url
  }
  date
  authorCollection(limit: 10) {
    items {
      fullName
    }
  }
  reviewerCollection(limit: 10) {
    items {
      fullName
    }
  }
  articleDescription {
    json
  }
  ...CareResourcesPersonalizationCardFragment
  articleBody {
    json
    links {
      entries {
        hyperlink {
          sys {
            id
          }
          __typename
          ... on CareResourcesProduct {
            ...ContentfulArticleProductFragment
          }
        }
      }
      assets {
        block {
          ...ContentfulAssetFragment
        }
      }
    }
  }
}
    ${CareResourcesPersonalizationCardFragmentDoc}
${ContentfulArticleProductFragmentDoc}
${ContentfulAssetFragmentDoc}`;
export const CareResourcesArticleLinkFragmentDoc = gql`
    fragment CareResourcesArticleLinkFragment on ArticlePage {
  image {
    url
    title
    description
  }
  title
  slug
}
    `;
export const ContentfulCategoryFragmentDoc = gql`
    fragment ContentfulCategoryFragment on CareResourcesCategory {
  title
  emojiCode
  darkColor
}
    `;
export const ContentfulSectionPersonalizedTextFragmentDoc = gql`
    fragment ContentfulSectionPersonalizedTextFragment on CareResourcesSectionPersonalizedText {
  reason {
    reasonId
  }
  personalizedText {
    json
  }
  category {
    ...ContentfulCategoryFragment
  }
}
    ${ContentfulCategoryFragmentDoc}`;
export const ContentfulSectionFragmentDoc = gql`
    fragment ContentfulSectionFragment on CareResourcesSection {
  sectionId
  title
  priority
  itemsCollection(limit: 40) {
    items {
      ... on ArticlePage {
        ...CareResourcesArticleLinkFragment
      }
      ... on CareResourcesLink {
        ...CareResourcesOtherLinkFragment
      }
      ... on CareResourcesProduct {
        ...CareResourcesProductFragment
      }
    }
  }
  personalizedTextCollection(limit: 10) {
    items {
      ...ContentfulSectionPersonalizedTextFragment
    }
  }
}
    ${CareResourcesArticleLinkFragmentDoc}
${CareResourcesOtherLinkFragmentDoc}
${CareResourcesProductFragmentDoc}
${ContentfulSectionPersonalizedTextFragmentDoc}`;
export const GetCareResourcesArticleDocument = gql`
    query getCareResourcesArticle($articleSlug: String!) {
  articlePageCollection(limit: 1, where: {slug: $articleSlug}) {
    items {
      ...ContentfulArticleFragment
    }
  }
}
    ${ContentfulArticleFragmentDoc}`;

/**
 * __useGetCareResourcesArticleQuery__
 *
 * To run a query within a React component, call `useGetCareResourcesArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareResourcesArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareResourcesArticleQuery({
 *   variables: {
 *      articleSlug: // value for 'articleSlug'
 *   },
 * });
 */
export function useGetCareResourcesArticleQuery(baseOptions: Apollo.QueryHookOptions<GetCareResourcesArticleQuery, GetCareResourcesArticleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareResourcesArticleQuery, GetCareResourcesArticleQueryVariables>(GetCareResourcesArticleDocument, options);
      }
export function useGetCareResourcesArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareResourcesArticleQuery, GetCareResourcesArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareResourcesArticleQuery, GetCareResourcesArticleQueryVariables>(GetCareResourcesArticleDocument, options);
        }
export type GetCareResourcesArticleQueryHookResult = ReturnType<typeof useGetCareResourcesArticleQuery>;
export type GetCareResourcesArticleLazyQueryHookResult = ReturnType<typeof useGetCareResourcesArticleLazyQuery>;
export type GetCareResourcesArticleQueryResult = Apollo.QueryResult<GetCareResourcesArticleQuery, GetCareResourcesArticleQueryVariables>;
export const GetCareResourcesSummaryDocument = gql`
    query getCareResourcesSummary($sectionIds: [String!]!) {
  careResourcesSectionCollection(limit: 40, where: {sectionId_in: $sectionIds}) {
    items {
      ...ContentfulSectionFragment
    }
  }
}
    ${ContentfulSectionFragmentDoc}`;

/**
 * __useGetCareResourcesSummaryQuery__
 *
 * To run a query within a React component, call `useGetCareResourcesSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareResourcesSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareResourcesSummaryQuery({
 *   variables: {
 *      sectionIds: // value for 'sectionIds'
 *   },
 * });
 */
export function useGetCareResourcesSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetCareResourcesSummaryQuery, GetCareResourcesSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareResourcesSummaryQuery, GetCareResourcesSummaryQueryVariables>(GetCareResourcesSummaryDocument, options);
      }
export function useGetCareResourcesSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareResourcesSummaryQuery, GetCareResourcesSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareResourcesSummaryQuery, GetCareResourcesSummaryQueryVariables>(GetCareResourcesSummaryDocument, options);
        }
export type GetCareResourcesSummaryQueryHookResult = ReturnType<typeof useGetCareResourcesSummaryQuery>;
export type GetCareResourcesSummaryLazyQueryHookResult = ReturnType<typeof useGetCareResourcesSummaryLazyQuery>;
export type GetCareResourcesSummaryQueryResult = Apollo.QueryResult<GetCareResourcesSummaryQuery, GetCareResourcesSummaryQueryVariables>;
export const GetSectionForHealthConditionDocument = gql`
    query getSectionForHealthCondition($conditionId: String!) {
  healthConditionCollection(limit: 1, where: {id: $conditionId}) {
    items {
      careResourcesSectionsCollection(limit: 1) {
        items {
          ...ContentfulSectionFragment
        }
      }
    }
  }
}
    ${ContentfulSectionFragmentDoc}`;

/**
 * __useGetSectionForHealthConditionQuery__
 *
 * To run a query within a React component, call `useGetSectionForHealthConditionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSectionForHealthConditionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSectionForHealthConditionQuery({
 *   variables: {
 *      conditionId: // value for 'conditionId'
 *   },
 * });
 */
export function useGetSectionForHealthConditionQuery(baseOptions: Apollo.QueryHookOptions<GetSectionForHealthConditionQuery, GetSectionForHealthConditionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSectionForHealthConditionQuery, GetSectionForHealthConditionQueryVariables>(GetSectionForHealthConditionDocument, options);
      }
export function useGetSectionForHealthConditionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSectionForHealthConditionQuery, GetSectionForHealthConditionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSectionForHealthConditionQuery, GetSectionForHealthConditionQueryVariables>(GetSectionForHealthConditionDocument, options);
        }
export type GetSectionForHealthConditionQueryHookResult = ReturnType<typeof useGetSectionForHealthConditionQuery>;
export type GetSectionForHealthConditionLazyQueryHookResult = ReturnType<typeof useGetSectionForHealthConditionLazyQuery>;
export type GetSectionForHealthConditionQueryResult = Apollo.QueryResult<GetSectionForHealthConditionQuery, GetSectionForHealthConditionQueryVariables>;